import { Navigate } from 'react-router-dom'
import { useAppSelector } from '~/app/hooks'
import { PATH_NAME } from '~/constants/paths'
import { USER_ROLE } from '~/constants/userRole'
import { selectAuth } from '~/redux/features'
import { getHighestRole } from '~/utils'

export const DefaultRoute = () => {
  const { roles: userRoles } = useAppSelector(selectAuth)

  if (getHighestRole(userRoles) === USER_ROLE.ADMIN) {
    return <Navigate to={PATH_NAME.USERS.path} />
  }
  if (getHighestRole(userRoles) === USER_ROLE.TECHNICIAN) {
    return <Navigate to={PATH_NAME.PROFILE_SETTING.path} />
  }
  return <Navigate to={PATH_NAME.DASHBOARD.path} />
}
